import type { ReactNode } from 'react';
import { useIntercom } from '@/hooks/useIntercom';
import type { IntercomUser } from '@/types/intercom';

interface IntercomProviderProps {
  readonly children: ReactNode;
  readonly user: IntercomUser | null;
  readonly enabled?: boolean;
  readonly intercomAppId?: string;
}

export function IntercomProvider({ children, user, enabled = true, intercomAppId }: IntercomProviderProps) {
  useIntercom({ user, enabled, intercomAppId });

  return <>{children}</>;
}
